import NotesTablet from './NotesTablet';

export default NotesTablet;
export { NotesTablet };
